import React from "react";
import { Box, Typography, Chip, Paper, Checkbox } from "@mui/material";
import { Assignment } from "@mui/icons-material";

const ChecklistCard = ({ checklists }) => {
  if (!checklists || checklists.length === 0) {
    return null;
  }

  const completedCount = checklists.filter((item) => item.is_done).length;
  const totalCount = checklists.length;

  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "8px",
            bgcolor: "#EFF8FF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Assignment sx={{ fontSize: 18, color: "#1570EF" }} />
        </Box>
        <Typography variant="subtitle2" fontWeight={600} color="#1A1A2E">
          Checklists
        </Typography>
        <Chip
          label={`${completedCount}/${totalCount}`}
          size="small"
          sx={{
            height: 20,
            fontSize: "0.65rem",
            fontWeight: 600,
            bgcolor: completedCount === totalCount ? "#D1FAE5" : "#F1F5F9",
            color: completedCount === totalCount ? "#059669" : "#475467",
          }}
        />
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {checklists.map((item) => (
          <Paper
            key={item.id}
            elevation={0}
            sx={{
              p: 1.5,
              px: 2,
              borderRadius: "8px",
              border: "1px solid #E2E8F0",
              bgcolor: item.is_done ? "#F0FDF4" : "#FFFFFF",
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              transition: "all 0.2s ease",
              "&:hover": {
                borderColor: item.is_done ? "#86EFAC" : "#94A3B8",
              },
            }}
          >
            <Checkbox
              checked={item.is_done}
              disabled
              size="small"
              sx={{
                color: "#94A3B8",
                "&.Mui-checked": {
                  color: "#22C55E",
                },
                p: 0,
              }}
            />
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="body2"
                fontWeight={500}
                color={item.is_done ? "#065F46" : "#1A1A2E"}
                sx={{
                  textDecoration: item.is_done ? "line-through" : "none",
                  opacity: item.is_done ? 0.7 : 1,
                }}
              >
                {item.checklist_name}
              </Typography>
              {item.required && (
                <Typography variant="caption" color="#EF4444" sx={{ ml: 0.5 }}>
                  *
                </Typography>
              )}
              {item.is_personalized && (
                <Chip
                  label="Custom"
                  size="small"
                  sx={{
                    height: 16,
                    fontSize: "0.5rem",
                    fontWeight: 500,
                    bgcolor: "#FEF3C7",
                    color: "#D97706",
                    ml: 1,
                  }}
                />
              )}
            </Box>
            {item.is_done ? (
              <Chip
                label="Done"
                size="small"
                sx={{
                  height: 18,
                  fontSize: "0.5rem",
                  fontWeight: 600,
                  bgcolor: "#D1FAE5",
                  color: "#059669",
                }}
              />
            ) : (
              <Chip
                label="Pending"
                size="small"
                sx={{
                  height: 18,
                  fontSize: "0.5rem",
                  fontWeight: 600,
                  bgcolor: "#FEF3C7",
                  color: "#D97706",
                }}
              />
            )}
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default ChecklistCard;